import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { Bell } from 'react-feather';

export const Notifications = () => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    const fetchNotifications = async () => {
      try {
        const q = query(collection(db, 'notifications'), where('to', '==', user.email));
        const snapshot = await getDocs(q);
        let data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        data.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
        data = data.slice(0, 10);
        setNotifications(data);
        setUnreadCount(data.filter(n => !n.read).length);
      } catch (err) { console.error('Error:', err); }
    };
    fetchNotifications();
  }, [user]);

  return (
    <div className="notification-wrapper">
      <button className="notification-btn" onClick={() => setShowDropdown(!showDropdown)}>
        <Bell size={18} />
      </button>
      {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
      
      {showDropdown && (
        <div className="notification-dropdown">
          <h4>Notifications</h4>
          {notifications.length === 0 ? (
            <p>No notifications</p>
          ) : (
            notifications.map(notif => (
              <div key={notif.id} className="notification-item">
                <p>{notif.message}</p>
                <span className="notification-time">{notif.createdAt?.toDate?.().toLocaleDateString()}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
